import { render, staticRenderFns } from "./PatientComment.vue?vue&type=template&id=2bbef4a3&scoped=true&lang=pug"
import script from "./PatientComment.vue?vue&type=script&lang=js"
export * from "./PatientComment.vue?vue&type=script&lang=js"
import style0 from "./PatientComment.vue?vue&type=style&index=0&id=2bbef4a3&prod&lang=scss&scoped=true"
import style1 from "./PatientComment.vue?vue&type=style&index=1&id=2bbef4a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbef4a3",
  null
  
)

export default component.exports